import React from "react";

import type { SxProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import RuiButton, { ButtonProps } from "@rui/Button";
import Link, { LinkProps } from "@rui/Link";
import TooltipWrapper from "@rui/TooltipWrapper";

interface BillingLinkButtonProps extends ButtonProps {
  children: React.ReactNode;
  disabledTooltip?: string;
  sx?: SxProps;
  testId?: string;
  to?: LinkProps["to"];
  openInBrowser?: LinkProps["openInBrowser"];
  href?: LinkProps["href"];
}

const Button = styled(RuiButton)(({ theme }) => ({
  height: "40px",
  borderRadius: theme.corners.small,
}));

const BillingLinkButton = ({
  children,
  disabledTooltip,
  sx,
  testId,
  variant = "contained",
  ...props
}: BillingLinkButtonProps) => {
  const isLink = props.href || props.openInBrowser || props.to;

  return (
    <TooltipWrapper
      show={props.disabled ?? false}
      title={
        disabledTooltip ??
        "You are not authorized to make changes to the billing plan for your Workspace"
      }
    >
      <Button
        data-test-id={testId}
        sx={sx}
        variant={variant}
        component={isLink ? Link : undefined}
        {...props}
      >
        {children}
      </Button>
    </TooltipWrapper>
  );
};

export default BillingLinkButton;
